module.exports = __webpack_public_path__ + "img/Populus_trichocarpa.44c6de77.jpg";